import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
//import { ConfigService } from '../config-serivce';
import { environment } from '../../../environments/environment';
@Injectable({
  providedIn: 'root',
})
export class HttpService {
  baseUrl: string;
  constructor(private http: HttpClient) {
    this.baseUrl = environment.apiUrl;
  }

  get<T>(url: string, options?: Object): Observable<T> {
    return this.http.get<T>(`${this.baseUrl}/${url}`, options);
  }

  deleteWithBody<T>(url: string, body: Object): Observable<T> {
    return this.http.request<T>('DELETE', `${this.baseUrl}/${url}`, {
      body: body,
    });
  }

  put<T>(url: string, body: Object): Observable<T> {
    return this.http.put<T>(`${this.baseUrl}/${url}`, body);
  }

  delete<T>(url: string): Observable<T> {
    return this.http.delete<T>(`${this.baseUrl}/${url}`);
  }

  post<T>(url: string, body: Object): Observable<T> {
    return this.http.post<T>(`${this.baseUrl}/${url}`, body);
  }
  //post for blobs
  postBlob<T>(endpoint: string, body: Object): Observable<HttpResponse<Blob>> {
    return this.http.post(`${this.baseUrl}/${endpoint}`, body, {
      observe: 'response',
      responseType: 'blob',
    });
  }

  patch<T>(url: string, body?: Object): Observable<T> {
    return this.http.patch<T>(`${this.baseUrl}/${url}`, body);
  }
}
